import { Link } from 'react-router-dom'

export default function CTAButton({ variant = 'primary', href, to, children, className = '', size = 'md', ...props }) {
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  }
  const variants = {
    primary:   'bg-kart-action text-white hover:-translate-y-0.5 shadow-md hover:shadow-lg hover:bg-[#e8502e]',
    secondary: 'bg-kart-blue text-white hover:-translate-y-0.5 shadow-md hover:shadow-lg hover:bg-[#1d4fd8]',
    ghost:     'border-2 border-kart-blue text-kart-blue bg-transparent hover:bg-kart-blue/5',
    'ghost-white': 'border-2 border-white text-white bg-transparent hover:bg-white/10',
  }
  const base = `inline-flex items-center justify-center font-medium rounded-xl transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kart-blue focus-visible:ring-offset-2 ${sizes[size]} ${variants[variant] ?? variants.primary} ${className}`

  if (href) return <a href={href} className={base} {...props}>{children}</a>
  if (to)   return <Link to={to} className={base} {...props}>{children}</Link>
  return <button className={base} {...props}>{children}</button>
}
